import React from 'react';
import PrimaryButton from './components/PrimaryButton/PrimaryButton';
import { Dialog, DialogContent } from './components/Dialog';

export const ApiCallErrorMessage = ({ isShow, onHide, apiResponseText, additionalText }) => (
  <Dialog
    open={isShow}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        onHide();
      }
    }}
  >
    <DialogContent
      className='w-[min(92vw,50rem)] rounded-[1.2rem] border-0 bg-white p-0 text-[1.6rem] shadow-[0_20px_50px_rgba(15,23,42,0.28)]'
      overlayClassName='bg-black/50'
    >
      <div className='relative border-b border-slate-200 px-[2rem] pb-[1.4rem] pt-[1.6rem]'>
        <button
          type='button'
          aria-label='Close'
          onClick={onHide}
          className='absolute right-[1.2rem] top-[1.2rem] flex h-[2.6rem] w-[2.6rem] items-center justify-center rounded-full border-0 bg-transparent p-0 text-[2.2rem] leading-none text-slate-600 outline-none transition-colors hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus-visible:ring-1 focus-visible:ring-slate-300'
        >
          ×
        </button>
        <h3 className="m-0 font-['GT-Walsheim-Pro-Bold'] text-[2.2rem] leading-[1.2] text-slate-800">Server Error</h3>
      </div>
      <div className='px-[2rem] pb-[2rem] pt-[1.6rem]'>
        <div className='rounded-[0.8rem] border border-slate-200 bg-slate-50 px-[1.4rem] py-[1.2rem]'>
          <div className='text-[1.3rem] font-semibold uppercase tracking-[0.04em] text-slate-500'>Server Response</div>
          <div className='mt-[0.5rem] break-words text-[1.9rem] leading-[1.25] text-slate-800'>{apiResponseText}</div>
        </div>
        <p className='mb-0 mt-[2rem] text-[1.7rem] leading-[1.4] text-slate-700'>
          There was a problem completing your request
        </p>
        {additionalText && (
          <p className='mb-0 mt-[0.9rem] text-[1.6rem] leading-[1.4] text-slate-600'>{additionalText}</p>
        )}
        <div className='mt-[2.4rem] flex justify-center'>
          <PrimaryButton small onClick={onHide}>
            Okay
          </PrimaryButton>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
